// extracted by mini-css-extract-plugin
module.exports = {"seats":"seats-1DPVz","seats_aggregator":"seats_aggregator-1EksE"};